import React from 'react';
import { Select } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { SelectAdapter } from './SelectAdapter';
import { SELECT_ADDRESS_FIELD } from '../addressUtils/addressConstants';
import { isRequired } from '../../../utils/validation';

const SelectAddressComponent = ({
  type,
  postCodeAddressList,
  onSelectAddressClick,
  currentIndex
}) => (
  <Content>
    {content => (
      <Field
        name={`${type}.${SELECT_ADDRESS_FIELD}`}
        subscription={{ touched: true, error: true, active: true }}
      >
        {({ meta: { touched, error, active } }) => (
          <FormField>
            <FieldHeader
              name={`${type}.${SELECT_ADDRESS_FIELD}`}
              hasError={touched && !!error}
              title={`Choose address`}
              validationMessage={content.selectListError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field
                name={`${type}.${SELECT_ADDRESS_FIELD}`}
                component="select"
                validate={isRequired}
              >
                {({ input }) => (
                  <SelectAdapter
                    active={active}
                    value={input.value}
                    onChange={v => {
                      onSelectAddressClick(
                        getAddressId(v, postCodeAddressList),
                        type,
                        currentIndex
                      );
                    }}
                  >
                    <BlockFieldColumn column={6}>
                      <Select
                        name={`${type}.${SELECT_ADDRESS_FIELD}`}
                        {...input}
                        options={[{ value: '', label: content.selectLabel }].concat(
                          postCodeAddressList
                        )}
                      />
                    </BlockFieldColumn>
                  </SelectAdapter>
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

const getAddressId = (address, postCodeAddressList) =>
  postCodeAddressList.filter(v => v.label === address)[0].id;

export default SelectAddressComponent;
